import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface RemoveFavorite {
	uriParams: Api.Operations['removeFavorite']['parameters']['path']
	response: Api.Operations['removeFavorite']['responses']['204']
}

export const removeFavorite = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<RemoveFavorite>(
		{
			method: 'delete',
			url: '/me/favorites/{spaceId}',
			...overideConfig,
		},
		axiosInstance,
	)
